'use client';

import {
  AtomicDidYouMean,
  AtomicLayoutSection,
  AtomicQuerySummary,
} from '@coveo/atomic-react';

export const AtomicStatusSection = () => {
  return (
    <AtomicLayoutSection section="status">
      <style>
        {`
          atomic-did-you-mean::part(no-results),
          atomic-did-you-mean::part(auto-corrected),
          atomic-query-summary::part(container) {
              color: var(--atomic-custom-grey-600);
          }    
      `}
      </style>
      <AtomicDidYouMean />
      <AtomicQuerySummary />
    </AtomicLayoutSection>
  );
};
